<script lang="ts">
  import { defineComponent } from 'vue';
  import Mixins from '@/helpers/mixins';
  import { OrderListPreselect } from '@/helpers/types';

  export default defineComponent({
    mixins: [Mixins],
    props: {
      orderListPreselect: {
        type: Object as () => OrderListPreselect,
        required: true,
      },
    },
    emits: {
      close: () => true,
    },
    computed: {
      filterString(): string {
        const status = this.orderListPreselect.filterStatus
          ? this.$t(`common.statuses.${this.orderListPreselect.filterStatus}`)
          : null;

        const prioritised = this.orderListPreselect.prioritised
          ? this.$t('common.prioritised')
          : null;

        const riskAssessment = this.orderListPreselect.riskAssessment
          ? this.$t('common.risk_assessment')
          : null;

        return [
          status,
          this.orderListPreselect.serviceLabel,
          prioritised,
          riskAssessment,
        ]
          .filter((term) => !!term)
          .join(', ');
      },
    },
    methods: {
      onNotificationClicked(): void {
        this.$emit('close');
      },
    },
  });
</script>

<template>
  <div @click="onNotificationClicked">
    <div class="d-flex flex-row gap-12 align-items-center">
      <img
        :alt="$t('common.img_alts.filter')"
        :src="imgUrl('icons/notifications/filter_blue.svg')"
        height="20"
        width="20"
      />
      <p>
        {{ filterString }}
      </p>
    </div>
  </div>
</template>
